import { TEAM_META } from '../data/teams';
import { prefersReducedMotion } from './motion';

// Lightweight, dependency-free confetti — spawns coloured pieces and animates
// them with the Web Animations API, then removes them. Shared by the games'
// win screens so we don't pull in a confetti package.
const DEFAULT_CONFETTI_COLORS = [
  TEAM_META.vikings.color, TEAM_META.panthers.color, '#f59e0b', '#10b981', '#ef4444', '#f96516',
];

// options.colors — restrict the palette (the draft fires a burst in the colour
//                  of whichever team just claimed a player).
// options.count  — fewer pieces for the many small bursts during the draft, so
//                  a 16-player ceremony does not spawn 2000 nodes.
export function burstConfetti(options = {}) {
  if (typeof document === 'undefined' || typeof document.body.animate === 'undefined') return;
  if (prefersReducedMotion()) return;
  const colors = (options.colors && options.colors.length) ? options.colors : DEFAULT_CONFETTI_COLORS;
  const count = Number.isFinite(options.count) ? options.count : 140;
  for (let n = 0; n < count; n++) {
    const el = document.createElement('div');
    const size = 6 + Math.random() * 8;
    el.style.cssText = `position:fixed;top:-12px;left:${Math.random() * 100}vw;width:${size}px;height:${size}px;` +
      `background:${colors[n % colors.length]};z-index:9999;pointer-events:none;` +
      `border-radius:${Math.random() > 0.5 ? '50%' : '2px'};`;
    document.body.appendChild(el);
    const dx = (Math.random() - 0.5) * 320;
    const rot = Math.random() * 720;
    const dur = 2200 + Math.random() * 1600;
    const anim = el.animate(
      [
        { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
        { transform: `translate(${dx}px, ${window.innerHeight + 60}px) rotate(${rot}deg)`, opacity: 1, offset: 0.85 },
        { transform: `translate(${dx}px, ${window.innerHeight + 60}px) rotate(${rot}deg)`, opacity: 0 },
      ],
      { duration: dur, easing: 'cubic-bezier(.2,.6,.4,1)' }
    );
    anim.onfinish = () => el.remove();
  }
}
